import Podcasts from "./../images/search/Podcasts.jpeg";
import LiveEvents from "./../images/search/liveEvents.jpg";
import MadeForyou from "./../images/search/MadeForYou.png";
import NewRelease from "./../images/search/NewRelease.jpeg";
import Hindi from "./../images/search/Hindi.jpeg";
import Tamil from "./../images/search/Tamil.jpeg";
import Charts from "./../images/search/Charts.jpg";
import Pop from "./../images/search/Pop.jpeg";
import Love from "./../images/search/love.jpeg";

const CategoryData = [
  {
    name: "Podcasts",
    url: Podcasts,
    color: "rgb(225, 51, 0)",
  },
  {
    name: "Live Events",
    url: LiveEvents,
    color: "rgb(115, 88, 255)",
  },
  {
    name: "Love",
    url: Love,
    color: "rgb(141, 103, 171)",
  },
  {
    name: "Made for you",
    url: MadeForyou,
    color: "rgb(30, 50, 100)",
  },
  {
    name: "New Release",
    url: NewRelease,
    color: "rgb(232, 17, 91)",
  },
  {
    name: "Hindi",
    url: Hindi,
    color: "rgb(233, 20, 41)",
  },
  {
    name: "Tamil",
    url: Tamil,
    color: "rgb(165, 103, 82)",
  },
  {
    name: "Charts",
    url: Charts,
    color: "rgb(141, 103, 171)",
  },
  {
    name: "POP",
    url: Pop,
    color: "rgb(20, 138, 8)",
  },
];

export default CategoryData;
